var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZapCircleFilled = function SvgZapCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M7.362 12.247 12 5.5v5h3.98c.492 0 .738 0 .873.102a.5.5 0 0 1 .196.373c.008.169-.131.372-.41.778L12 18.5v-5H8.02c-.492 0-.739 0-.873-.102a.5.5 0 0 1-.196-.373c-.008-.169.131-.372.41-.778",
    clipRule: "evenodd"
  })));
};
export default SvgZapCircleFilled;